"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Label = void 0;
var text_1 = require("@newfront-insurance/core-ui/dist/src/components/text");
var react_1 = __importDefault(require("react"));
/**
 * Renders label text given a label
 * @param props
 */
function Label(_a) {
    var name = _a.name, label = _a.label, _b = _a.size, size = _b === void 0 ? 'small' : _b, _c = _a.color, color = _c === void 0 ? 'light' : _c;
    return (react_1.default.createElement(text_1.Text, { size: size, color: color, testId: "Label-" + name }, label));
}
exports.Label = Label;
